import * as Yup from 'yup'
import {BaseEntity} from '../../../../shared/models/ApiModels'
import {ITagModel} from '../tag/TagModel'

export const HR_APPLICATION_PATH = '/hr/application'

export type TrackingStatus = 'IN_PROGRESS' | 'COMPLETED' | 'CANCELLED'

export const TRACKING_STATUS_OPTIONS: {value: TrackingStatus; label: string}[] = [
  {value: 'IN_PROGRESS', label: 'Devam ediyor'},
  {value: 'COMPLETED', label: 'Tamamlandı'},
  {value: 'CANCELLED', label: 'İptal edildi'},
]

export const TRACKING_STATUS_BADGE: Record<TrackingStatus, string> = {
  IN_PROGRESS: 'badge-light-primary',
  COMPLETED: 'badge-light-success',
  CANCELLED: 'badge-light-danger',
}

export const trackingStatusLabel = (status?: string | null) =>
  TRACKING_STATUS_OPTIONS.find((option) => option.value === status)?.label ?? status ?? ''

export interface IApplicationAnswer {
  questionId: string
  questionLabel: string
  value: string
}

/** ApplyJobDto */
export interface IApplicationModel extends BaseEntity {
  jobId: string
  jobTitle: string
  hrProcessId?: string | null
  hrProcessName?: string | null
  candidateId?: string | null
  /** Adayın (havuzdaki kaydın) etiketleri */
  tags?: ITagModel[]
  /** Süreç başlatılmışsa aday takip kaydı */
  trackingId?: string | null
  trackingStatus?: TrackingStatus | null
  currentStepName?: string | null
  firstname: string
  lastname: string
  email: string
  phone?: string | null
  candidateLocation?: string | null
  documentId?: string | null
  consentTerms: boolean
  consentPrivacy: boolean
  consentFutureContact: boolean
  questions: IApplicationAnswer[]
  /** PUBLIC: ilan sayfası, MANUAL: İK, CALL_POOL: arama havuzunda aday adına açılan */
  source?: 'PUBLIC' | 'MANUAL' | 'CALL_POOL' | null
  /** Süreci başlatılmadan verilen sonuç (arama havuzunda olumsuz) */
  outcome?: 'POSITIVE' | 'NEGATIVE' | null
  createdDate?: string
}

/** PATCH /apply-job/update gövdesi */
export interface IApplicationUpdateRequest {
  firstname: string
  lastname: string
  email: string
  phone: string
  candidateLocation: string
}

export const validationApplicationUpdate = Yup.object().shape({
  firstname: Yup.string().trim().required('Ad zorunludur').max(100),
  lastname: Yup.string().trim().required('Soyad zorunludur').max(100),
  email: Yup.string().trim().required('E-posta zorunludur').email('Geçerli bir e-posta adresi giriniz').max(150),
  phone: Yup.string().trim().max(30),
  candidateLocation: Yup.string().trim().max(150),
})

export const fullName = (person: {firstname?: string | null; lastname?: string | null}) =>
  [person.firstname, person.lastname].filter(Boolean).join(' ')

/** Evet/Hayır sorularının cevabı "true"/"false" olarak saklanır */
export const formatAnswer = (value: string) =>
  value === 'true' ? 'Evet' : value === 'false' ? 'Hayır' : value
